module.exports = __webpack_public_path__ + "a6800e603e28f45320a75fcd63cccc8a.gif";